import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "Naturaleza del sitio",
    body: "Este sitio es informativo. Presenta los servicios de desarrollo, representación y gestión de modelos y creadoras de contenido en el mundo digital que ofrece Exclusive Society. Ningún contenido del sitio constituye una oferta contractual vinculante.",
  },
  {
    title: "Exclusivo para mayores de 18 años",
    body: "El sitio y los servicios descritos están dirigidos exclusivamente a personas mayores de 18 años. Al enviar una postulación confirmas que cumples este requisito.",
  },
  {
    title: "Sin garantía de ingresos",
    body: "No prometemos ingresos garantizados, riqueza inmediata ni un estilo de vida asegurado. Los resultados de cualquier proyecto digital dependen de la demanda, la audiencia, el contenido, la constancia y las condiciones de las plataformas.",
  },
  {
    title: "Condiciones comerciales",
    body: "Las condiciones comerciales, la comisión de la agencia (35 % de la base neta), los plazos, los gastos y las causas de término se definen y formalizan por escrito en un contrato individual que se revisa antes de contratar. El resumen publicado en este sitio es informativo y no reemplaza ese contrato.",
  },
  {
    title: "Consentimiento y límites",
    body: "Ningún compromiso comercial obliga a producir contenido íntimo ni impide retirar el consentimiento. La creadora define y registra sus límites antes de comenzar y conserva acceso a su cuenta de contenido y a su información financiera.",
  },
  {
    title: "Propiedad intelectual",
    body: "Los textos, la identidad visual y los materiales de este sitio pertenecen a Exclusive Society y no pueden reproducirse sin autorización.",
  },
  {
    title: "Modificaciones",
    body: "Podemos actualizar estos términos para reflejar cambios en el sitio o en los servicios. La versión vigente será siempre la publicada en esta página.",
  },
];

export default function Terminos() {
  return (
    <div data-testid="terminos-page">
      <section className="py-20 lg:py-28">
        <div className="max-w-3xl mx-auto px-4 sm:px-8">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-mauve font-sans font-semibold">Legal</span>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink mt-4 leading-[1.1]">
              Términos del sitio.
            </h1>
            <p className="mt-8 text-base font-light text-stone2 leading-relaxed">
              Estos términos regulan el uso de este sitio web. Al navegarlo aceptas las condiciones descritas a
              continuación.
            </p>
          </Reveal>
          <div className="mt-14 space-y-10">
            {SECTIONS.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.05}>
                <section data-testid={`terminos-section-${i + 1}`} className="border-l-2 border-champagne pl-6">
                  <h2 className="font-serif text-2xl text-ink">{s.title}</h2>
                  <p className="mt-3 text-base font-light text-stone2 leading-relaxed">{s.body}</p>
                </section>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
